import '../styles/DemandStatus.css';

import { observer }            from 'mobx-react';
import FormattedMessageWrapper from 'components/App/FormattedMessageWrapper';
import DemandModel             from 'models/DemandModel';
import { ApiCollection }       from 'collections/ApiCollection';
import DemandStatusModel       from 'models/DemandStatusModel';

const DemandStatus = observer(({ demand, demandStatusCollection }: { demand: DemandModel, demandStatusCollection: ApiCollection<DemandStatusModel> }) => {
  const demandStatus = demandStatusCollection.find(ds => ds.id === demand.get('demandStatus.id'));

  if (!demandStatus) {
    return null;
  }

  return (
    <div className={`demandStatus-${demandStatus.reference}`}>
      <FormattedMessageWrapper id={demandStatus.label} />
    </div>
  );
});

export default DemandStatus;
